// A league is identified as "area/league" ("england/premier-league"), the same key normalizeMatch
// gives each match (leagueKey). Several selected leagues live in the URL as /leagues?l=key1,key2.

export function parseLeagueKeys(value) {
  const keys = (value || '').split(',').map((k) => k.trim()).filter((k) => /^[^/]+\/[^/]+$/.test(k));
  return [...new Set(keys)];
}

// The page that shows exactly these leagues: home for none, the league page for one.
export function leagueSelectionPath(keys) {
  if (keys.length === 0) {
    return '/';
  }
  if (keys.length === 1) {
    return `/league/${keys[0]}`;
  }
  return `/leagues?l=${keys.join(',')}`;
}

export function toggleLeague(keys, key) {
  return keys.includes(key) ? keys.filter((k) => k !== key) : [...keys, key];
}
